import { getFirstItem, setKey } from 'lib/util'
import search from 'app/_shared/events/search'

/**
 * Attempts to set the model sensor's id by looking for the newest sensor with the same serial as
 * the current pairing model.
 *
 * @param obj
 */
const setPairingSensorRef = (
  obj: Gaia.AppModule.Spec,
) => async (
  ...args: any[]
): Promise<any[]> => {
  // Before clearing the pairing model, we set the key  of its
  // sensor so that we can redirect to it just after the pairing
  const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]
  const { pairing, sensor } = obj[G.MODEL][G.CHILDREN]

  const { serial } = pairing[G.DATA]

  const filter = { serial }
  const type = 'x_eco_apmsensor'
  const sort = [["submit_timestamp<number>", "desc"]]
  const options = { type, filter, sort }

  try {
    const sensors = await search(null, obj, actionComponent, options)
    const found = getFirstItem(sensors)

    if (found) {
      setKey(found.key, G.REF, sensor[G.STATE])
    }
  } catch (cause) {
    throw new Error('Unable to set sensor id from pairing model', { cause })
  }

  return args
}

export default setPairingSensorRef
